import React from "react";
import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const textAreaClasses = cva(
  "transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed resize-none",
  {
    variants: {
      variant: {
        primary: "focus:ring-blue-500",
        secondary: "focus:ring-green-500",
        outline: "bg-transparent focus:ring-blue-500",
      },
      size: {
        small: "text-sm px-3 py-2 min-h-[80px]",
        medium: "text-base px-4 py-3 min-h-[100px]",
        large: "text-lg px-6 py-4 min-h-[120px]",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "medium",
    },
  }
);

const TextArea = ({
  // Required parameters with defaults
  placeholder = "Message",
  //   text_font_size = "30",
  text_font_family = "Sora",
  text_font_weight = "400",
  text_line_height = "38px",
  text_text_align = "left",
  text_color = "#1c233a4c",
  border_border = "1px solid #1c233a",
  //   border_border_radius = "50px",

  // Optional parameters (no defaults)
  layout_width,
  padding,
  position,

  // Standard React props
  variant,
  size,
  disabled = false,
  className,
  value,
  onChange,
  onFocus,
  onBlur,
  rows = 4,
  ...props
}) => {
  // Safe validation for optional parameters
  const hasValidWidth =
    layout_width &&
    typeof layout_width === "string" &&
    layout_width?.trim() !== "";
  const hasValidPadding =
    padding && typeof padding === "string" && padding?.trim() !== "";
  const hasValidPosition =
    position && typeof position === "string" && position?.trim() !== "";

  // Build optional Tailwind classes
  const optionalClasses = [
    hasValidWidth ? `w-[${layout_width}]` : "w-full",
    hasValidPadding ? `p-[${padding}]` : "",
    hasValidPosition ? position : "",
  ]
    ?.filter(Boolean)
    ?.join(" ");

  // Build inline styles for required parameters
  const textAreaStyles = {
    // fontSize: `${text_font_size}px`,
    fontFamily: text_font_family,
    fontWeight: text_font_weight,
    lineHeight: text_line_height,
    textAlign: text_text_align,
    color: text_color,
    border: border_border,
    // borderRadius: border_border_radius,
  };

  return (
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      rows={rows}
      style={textAreaStyles}
      className={twMerge(
        textAreaClasses({ variant, size }),
        optionalClasses,
        className
      )}
      aria-disabled={disabled}
      {...props}
    />
  );
};

export default TextArea;
